import { makeStyles, shorthands } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },

  cardHover: {
    transition: `all ${designTokens.transition.fast}`,
    ":hover": {
      ...shorthands.borderColor(designTokens.neutral[300]),
      boxShadow: designTokens.shadow.md,
    },
  },

  tag: {
    display: "inline-flex",
    fontWeight: designTokens.fontWeight.medium,
    fontSize: designTokens.fontSize.xs,
    ...shorthands.padding(designTokens.spacing[1], designTokens.spacing[2]),
    borderRadius: designTokens.borderRadius.sm,
    alignSelf: "flex-start",
    marginBottom: designTokens.spacing[2],
    backgroundColor: designTokens.neutral[100],
    color: designTokens.neutral[700],
  },
  tagSelling: {
    backgroundColor: designTokens.primary[100],
    color: designTokens.primary[700],
  },

  chips: {
    display: "flex",
    alignItems: "center",
    columnGap: designTokens.spacing[1],
    rowGap: designTokens.spacing[1],
    marginBottom: designTokens.spacing[2],
    flexWrap: "wrap",
  },
  chipFeature: {
    padding: `2px ${designTokens.spacing[2]}`,
    backgroundColor: designTokens.neutral[100],
    ...shorthands.border("1px", "solid", designTokens.neutral[200]),
    borderRadius: designTokens.borderRadius.sm,
    fontSize: designTokens.fontSize.xs,
    color: designTokens.neutral[600],
    fontWeight: designTokens.fontWeight.normal,
  },

  chipLlm: {
    padding: `2px ${designTokens.spacing[2]}`,
    backgroundColor: designTokens.accent[50],
    ...shorthands.border("1px", "solid", designTokens.accent[200]),
    borderRadius: designTokens.borderRadius.sm,
    fontSize: designTokens.fontSize.xs,
    color: designTokens.accent[600],
    fontWeight: designTokens.fontWeight.medium,
    cursor: "default",
  },

  titleRow: {
    display: "flex",
    alignItems: "center",
    columnGap: designTokens.spacing[2],
    fontWeight: designTokens.fontWeight.semibold,
    fontSize: designTokens.fontSize.sm,
    color: designTokens.neutral[900],
    marginBottom: designTokens.spacing[1],
    maxWidth: "100%",
  },
  infoIcon: {
    cursor: "pointer",
    width: "14px",
    height: "14px",
    flexShrink: 0,
    color: designTokens.neutral[400],
    ":hover": {
      color: designTokens.neutral[600],
    },
  },

  starButton: {
    position: "absolute",
    top: designTokens.spacing[2],
    right: designTokens.spacing[2],
    minWidth: "28px",
    width: "28px",
    height: "28px",
    padding: "0",
    color: designTokens.neutral[300],
  },
  starButtonFilled: {
    color: designTokens.semantic.warning,
    ":hover": {
      backgroundColor: designTokens.neutral[50],
      color: designTokens.semantic.warning,
    },
  },

  footer: {
    justifyContent: "space-between",
    display: "flex",
    paddingTop: designTokens.spacing[3],
    marginTop: "auto",
    ...shorthands.borderTop("1px", "solid", designTokens.neutral[100]),
    columnGap: designTokens.spacing[1],
  },
  footerLeftButtons: {
    display: "flex",
    columnGap: designTokens.spacing[3],
    alignItems: "center",
  },

  ratingRow: {
    display: "flex",
    alignItems: "center",
    columnGap: designTokens.spacing[2],
    marginBottom: designTokens.spacing[3],
  },

  iconButtonSize: {
    minWidth: "28px",
    width: "28px",
    height: "28px",
    padding: "0",
  },
});
